import { ShipmentsRightMenuStructure } from "../store";
import { SHIPMENT_LIST_RIGHT_MENU } from "redux/actions-constants/shipmentListRightMenu.constants";
const initialShipmentsRightMenu: ShipmentsRightMenuStructure = new ShipmentsRightMenuStructure



export function shipmentsRightMenuReducer(shipmentsRightMenu: ShipmentsRightMenuStructure = initialShipmentsRightMenu, action): ShipmentsRightMenuStructure {

    switch (action.type) {

        case SHIPMENT_LIST_RIGHT_MENU.SET_ID_MENU_SELECTION:
            return {
                ...shipmentsRightMenu,
                idMenuSelections: action.idMenuSelections
            }


        case SHIPMENT_LIST_RIGHT_MENU.SET_SITUATIONS:
            return {
                ...shipmentsRightMenu,
                situations: action.situations
            }

        case SHIPMENT_LIST_RIGHT_MENU.SET_INITIAL_DATE:
            return {
                ...shipmentsRightMenu,
                initialDate: action.initialDate
            }

        case SHIPMENT_LIST_RIGHT_MENU.SET_FINAL_DATE:
            return {
                ...shipmentsRightMenu,
                finalDate: action.finalDate
            }

        default:
            return shipmentsRightMenu
    }
}